"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleCampaignsGroupedByOrgResponseSchema = exports.AppleCampaignsWithOrgSchema = exports.ImportStandaloneCampaignResponseSchema = exports.ImportStandaloneCampaignBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const accounts_web_1 = require("../../accounts-web");
const apple_auth_web_1 = require("../../apple-auth-web");
const apple_channels_web_1 = require("../../apple-channels-web");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.ImportStandaloneCampaignBodySchema = (0, core_1.StrictObject)({
    orgRef: core_1.IdSchema,
    campaignRef: core_1.IdSchema,
    name: typebox_1.Type.String(),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    objective: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ImportStandaloneCampaignResponseSchema = (0, core_1.StrictObject)({
    campaign: accounts_web_1.GetCampaignResponseSchema,
    channel: typebox_1.Type.Union([
        apple_channels_web_1.AppleSearchResultsChannelResponseSchema,
        apple_channels_web_1.AppleSearchTabsChannelResponseSchema,
        apple_channels_web_1.AppleTodayTabChannelResponseSchema,
        apple_channels_web_1.AppleProductPageBrowseChannelResponseSchema,
    ]),
    regions: typebox_1.Type.Array(typebox_1.Type.Union([
        apple_channels_web_1.AppleSearchResultsRegionResponseSchema,
        apple_channels_web_1.AppleSearchTabsRegionResponseSchema,
        apple_channels_web_1.AppleTodayTabRegionResponseSchema,
        apple_channels_web_1.AppleProductPageBrowseRegionResponseSchema,
    ])),
});
exports.AppleCampaignsWithOrgSchema = typebox_1.Type.Object({
    org: typebox_1.Type.Object({
        orgRef: core_1.IdSchema,
        orgName: typebox_1.Type.String(),
        status: apple_auth_web_1.AppleOrganisationInfoStatusSchema,
        parentOrgRef: core_1.IdSchema,
    }),
    campaigns: typebox_1.Type.Array(typebox_1.Type.Object({
        campaignRef: (0, core_1.OptionalNullable)(core_1.IdSchema),
        campaignName: typebox_1.Type.String(),
        status: (0, core_1.OptionalNullable)(apple_proxy_web_1.AppleProxyStatusSchema),
        channelType: ruby_1.ChannelTypeSchema,
    })),
});
exports.AppleCampaignsGroupedByOrgResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleCampaignsWithOrgSchema);
